<template>
  <div class="app_container">
    <el-tabs type="card" v-model="activeTab" size="small" @tab-click="handleClick">
      <el-tab-pane v-for="item in leaderHomeTab" :label="item.paramValue" :name="item.paramKey" :key="'homeTab' + item.paramKey">
      </el-tab-pane>
    </el-tabs>
    <!-- 新课上线消息 ****备注：因为要缓存历史数据，所以两个tab分开处理 -->
    <div v-show="activeTab == '1'" class="new-table">
      <search class="search-wrapper" ref="search" @search="searchHandle" :expireStatusData="expireStatusData"/>
      <div class="handle_wrapper">
        <butn
          btntype="primary"
          title="配置"
          v-permission="'leaderHome:save'"
          @click="addConfig"
        ></butn>
        <butn
          class="btn-wrapper"
          v-permission="'leaderHome:delete'"
          btntype="primary"
          title="批量删除"
          @click="deleteBatch()"
          :disabled="!transferFlag"
        ></butn>
        <butn
          btntype="primary"
          title="同步干部之家"
          @click="pushNews"
          v-permission="'leaderHome:pushNews'"
        ></butn>
        <el-checkbox
          v-permission="'leaderHome:orderByDrag'"
          :disabled="dragDisabled"
          v-model="dragaable"
          class="drag-box"
          >拖拽排序
        </el-checkbox>
        <div class="msg_style">提示：列表配置课程，作为我的学习课程上新内容将显示在【干部之家消息页面】。</div>
      </div>
      <Table @selection-change="selectChange" :data="dataList" row-key="uuid" @deleteResource="deleteHomeConfig" />
      <div class="RCPagination">
        <RCPagination ref="pagination" v-model="dataList" :api="api" :startRequest="false"/>
      </div>
    </div>
    <!-- PC端首页课程 -->
    <div v-show="activeTab == '2'" class="pc-table">
      <search class="search-wrapper" ref="pcSearch" @search="searchHandle" :expireStatusData="expireStatusData" />
      <div class="handle_wrapper">
        <butn
          btntype="primary"
          title="配置"
          v-permission="'leaderHome:save'"
          @click="addConfig"
        ></butn>
        <butn
          class="btn-wrapper"
          v-permission="'leaderHome:delete'"
          btntype="primary"
          title="批量删除"
          @click="deleteBatch()"
          :disabled="!transferFlag"
        ></butn>
        <butn
          btntype="primary"
          title="同步干部之家"
          @click="pushNews"
          v-permission="'leaderHome:pushNews'"
        ></butn>
        <el-checkbox
          v-permission="'leaderHome:orderByDrag'"
          :disabled="dragDisabled"
          v-model="pcDragable"
          class="drag-box"
          >拖拽排序
        </el-checkbox>
        <div class="msg_style">提示：列表配置课程，作为干部之家PC端首页-我的学习模块展示课程。默认显示昨日点击量最高的4门课程，可手动调整。</div>
      </div>
      <PCTable @selection-change="selectPCChange" :data="pcDataList" row-key="uuid" @deleteResource="deleteHomeConfig"/>
      <div class="RCPagination">
        <RCPagination ref="pcPagination" v-model="pcDataList" :api="pcApi" :startRequest="false" />
      </div>
    </div>
    <div v-if="activeTab == 3" class="pc-table">
      <HomePopup />
    </div>
    <!--新课上线消息 资源选择-->
    <NewCourseManage
      @addSucceed="addConfigSucceed"
      :showNewCourseManage="showNewCourseManage"
      v-if="showNewCourseManage.flag"
      @closeManage="closeConfig"
    />
    <!--PC端首页课程 资源选择-->
    <PCCourseManage
      @addSucceed="addConfigSucceed"
      :showPCCourseManage="showPCCourseManage"
      v-if="showPCCourseManage.flag"
      @closeManage="closeConfig"
    />
  </div>
</template>

<script>
import Table from "./table.js";
import PCTable from "./pcTable.js";
import Search from "./search";
import RCPagination from "@/components/pagination/paginationManage";
import { getLeaderHomeConfigPage, deleteHomeConfig, configOrderByDrag, pushNews } from "@/api/video";
import butn from "@/components/button/index";
import NewCourseManage from "./newCourse/manageIndex.vue";
import PCCourseManage from "./pcCourse/manageIndex.vue";
import { getSysParamByTypes } from "@/api/sysParam";
import { Confirm } from "@/components/Confirm";
import Sortable from "sortablejs";

import HomePopup from "./homePopup"

export default {
  name: "gbzjConfig",
  components: {
    butn,
    Table,
    Search,
    RCPagination,
    PCTable,
    NewCourseManage,
    PCCourseManage,
    HomePopup
  },
  data() {
    return {
      dragaable: false,
      pcDragable: false,
      dataList: [],
      pcDataList: [],
      api: getLeaderHomeConfigPage,
      pcApi: getLeaderHomeConfigPage,
      checkArray: [],
      checkPCArray: [],
      dataname: {},
      showNewCourseManage: { flag: false },
      showPCCourseManage: { flag: false },
      activeTab: "",
      leaderHomeTab: [],
      expireStatusData: []
    };
  },
  watch: {
    // 两个拖拽状态 分开管理
    dragaable(val) {
      this.rowDrop(val);
    },
    pcDragable(val) {
      this.rowDrop(val);
    }
  },
  computed: {
    transferFlag() {
      if (this.activeTab == '1') {
        return this.checkArray.length > 0;
      } else return this.checkPCArray.length > 0;
    },
    dragDisabled() {
      if (this.activeTab == '1') {
        return this.dataList.length < 2;
      } else return this.pcDataList.length < 2
    },
  },
  created() {
    this.getSysParamByTypes(["LEADER_HOME_TAB", "EXPIRE_STATUS"]);
  },
  methods: {
    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        let tbody;
        if (_this.activeTab == '1') {
          tbody = document.querySelector(".new-table .el-table__body-wrapper tbody");
        } else {
          tbody = document.querySelector(".pc-table .el-table__body-wrapper tbody");
        }
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          // 开始拖拽的时候
          onEnd({ oldIndex, newIndex }) {
            if (oldIndex === newIndex) return;
            let oldRow;
            if (_this.activeTab == '1') {
              oldRow = _this.dataList[oldIndex];
            } else oldRow = _this.pcDataList[oldIndex];
            // 和其他拖拽偏移量规则相反
            let offset = oldIndex - newIndex;
            let params = {
              offset: offset,
              uuid: oldRow.uuid
            };
            configOrderByDrag(params).then(res => {
              if (!res || res.code != 0) return;
              _this.$message({
                message: "排序成功",
                type: "success"
              });
              if (_this.activeTab == '1') {
                const currR = _this.dataList.splice(oldIndex, 1)[0];
                _this.dataList.splice(newIndex, 0, currR);
              } else {
                const currR = _this.pcDataList.splice(oldIndex, 1)[0];
                _this.pcDataList.splice(newIndex, 0, currR);
              }
            });
          }
        });
      }
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.leaderHomeTab = res.data["LEADER_HOME_TAB"] || [];
        let active = this.$route.query.active || 0;
        let tabLen = this.leaderHomeTab.length - 1;
        active = tabLen >= 0 && active > tabLen  ? tabLen  : active;
        this.activeTab = this.leaderHomeTab[active].paramKey;
        this.expireStatusData = res.data["EXPIRE_STATUS"];
        this.$nextTick(() => {
          this.searchHandle({});
        });
        for(let i=0; i<this.leaderHomeTab.length; i++) {
          this.dataname[this.leaderHomeTab[i].paramKey] = {};
        }
      });
    },
    // 搜索
    searchHandle(params) {
      this.dataname[this.activeTab] = {...params};
      if (!params.expireStatus) {
        params.expireStatus = '2';
      }
      if (this.activeTab == '1') {
        this.$refs["pagination"].search({ ...params, configType: parseInt(this.activeTab) });
      } else if (this.activeTab == '2') {
        this.$refs["pcPagination"].search({ ...params, configType: parseInt(this.activeTab) });
      }
    },
    addConfig() {
      if (this.activeTab == '1') {
        this.showNewCourseManage.flag = true;
      } else this.showPCCourseManage.flag = true;
    },
    // 关闭配置弹窗
    closeConfig() {
      if (this.activeTab == '1') {
        this.showNewCourseManage.flag = false;
      } else if (this.activeTab == '2') this.showPCCourseManage.flag = false;
    },
    // 新增资源成功
    addConfigSucceed() {
      this.closeConfig();
      this.searchHandle(this.dataname[this.activeTab]);
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    selectPCChange(selections) {
      this.checkPCArray = selections;
    },
    // 删除资源
    async deleteHomeConfig(item) {
      try {
        await Confirm(`确认删除选中资源吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        deleteHomeConfig({ uuids: [item.uuid] }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.searchHandle(this.dataname[this.activeTab]);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 批量删除
    async deleteBatch() {
      let params;
      if (this.activeTab == '1') {
        params = this.checkArray.map(item => item.uuid)
      } else if (this.activeTab == '2') {
        params = this.checkPCArray.map(item => item.uuid);
      }
      try {
        await Confirm(`确认批量删除选中资源吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        deleteHomeConfig({ uuids: params }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.searchHandle(this.dataname[this.activeTab]);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    handleClick(tab) {
      this.activeTab = tab.name;
      this.searchHandle(this.dataname[this.activeTab]);
    },
    // 推送干部之家重新拉取信息
    pushNews() {
      pushNews({ configType: parseInt(this.activeTab) }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: res.msg,
          type: "success",
        });
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  float: right;
}
.msg_style {
  font-size: 14px;
  padding: 24px 0 12px;
}
/deep/ .drag-box {
  margin-left: 16px;
}
</style>
